import React from 'react';
import './Card.css';

/**
 * Card – reusable feature/service card.
 * Props: icon (JSX), title, desc, badge, accent (CSS color)
 */
export default function Card({ icon, title, desc, badge, children, accent }) {
  return (
    <div className="card" style={accent ? { '--card-accent': accent } : {}}>
      {accent && <div className="card__accent-bar" />}
      {icon && <div className="card__icon">{icon}</div>}
      <div className="card__body">
        {badge && <span className="badge badge--blue">{badge}</span>}
        {title && <h3 className="card__title">{title}</h3>}
        {desc  && <p  className="card__desc">{desc}</p>}
        {children}
      </div>
    </div>
  );
}